import type { TThunkAction } from 'shared/types/redux';
import { ECPDChatIdLoadingStatus } from 'shared/types/redux/cpd';
import { getChatId } from 'shared/api/cpd/getChatId';
import { selectCPDDraftId } from 'shared/selectors/cpd';

import { setCPDChatIdLoadingStatus } from './actions';

export const getCPDChatId = (): TThunkAction<Promise<string | null>> => async (dispatch, getState, context) => {
  const state = getState();
  const cpdDraftId = selectCPDDraftId(state);

  if (!cpdDraftId) {
    return null;
  }

  dispatch(setCPDChatIdLoadingStatus(ECPDChatIdLoadingStatus.Loading));

  const response = await getChatId({
    httpApi: context.httpApi,
    logger: context.logger,
    parameters: {
      cpdDraftId,
    },
  });

  if (response.isSuccess) {
    dispatch(setCPDChatIdLoadingStatus(ECPDChatIdLoadingStatus.Success));

    return response.chatId;
  }

  dispatch(setCPDChatIdLoadingStatus(ECPDChatIdLoadingStatus.Fail));

  return null;
};
